import { render, staticRenderFns } from "./atomicFission.vue?vue&type=template&id=be4ce0d8&scoped=true&"
import script from "./atomicFission.vue?vue&type=script&lang=js&"
export * from "./atomicFission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4ce0d8",
  null
  
)

export default component.exports